import OAS3SupportInfo from './OAS3SupportInfo';

export default OAS3SupportInfo;
